export const createCoinsRepository = (appFetch) => {
    return {
        list(params = {}) {
            return appFetch.get('/api/plugin/coins/v1/category-list', {params});
        },
    };
};
